import { defineStore } from 'pinia'
import { get } from '@/utils/api'

export const useTenantStore = defineStore('tenant', {
  state: () => ({
    tenantConfigs: [],
    selectedTheme: null,
    urlName: null,
    primaryColor: null,
    secondaryColor: null,
    customPrimaryColor: null,
    customSecondaryColor: null,
    logo: null,
    loading: false,
    error: null,
  }),

  getters: {
    getLogo: (state) => state.logo,
    getTheme: (state) => state.selectedTheme,
    getColors: (state) => ({
      primary: state.primaryColor,
      secondary: state.secondaryColor,
      customPrimary: state.customPrimaryColor,
      customSecondary: state.customSecondaryColor,
    }),
  },

  actions: {
    async fetchTenantConfigs(tenantId) {
      this.loading = true
      this.error = null
      try {
        const response = await get(`/v1/tenant-configs/tenant/${tenantId}`)
        if (response?.data?.code === 200) {
          const configs = response.data.data
          this.tenantConfigs = configs
          localStorage.setItem('TenantDetails', JSON.stringify(configs))

          // Extract specific configs
          this.selectedTheme = configs.find((config) => config.key === 'selected_theme')?.value
          this.urlName = configs.find((config) => config.key === 'url_name')?.value
          this.primaryColor = configs.find((config) => config.key === 'theme_primary_color')?.value
          this.secondaryColor = configs.find((config) => config.key === 'theme_secondary_color')?.value
          this.customPrimaryColor = configs.find((config) => config.key === 'custom_primary_color')?.value
          this.customSecondaryColor = configs.find((config) => config.key === 'custom_secondary_color')?.value

          // Fetch logo with better error handling
          try {
            const logoResponse = await get(`public/tenant-config?key=url_name&value=${this.urlName}`)

            // if (logoResponse?.data?.code === 200) {
            this.logo = logoResponse.data.data.logo
            // } else {
            //   this.logo = null
            // }
          } catch (logoError) {
            this.logo = null
          }

          return response
        }
      } catch (error) {
        this.error = error.response?.data?.message || 'Failed to fetch tenant configurations'
        throw error
      } finally {
        this.loading = false
      }
    },

    clearTenantConfigs() {
      this.tenantConfigs = []
      this.selectedTheme = null
      this.urlName = null
      this.primaryColor = null
      this.secondaryColor = null
      this.customPrimaryColor = null
      this.customSecondaryColor = null
      this.logo = null
    },
  },

  persist: {
    enabled: true,
    strategies: [
      {
        key: 'tenant',
        storage: localStorage,
      },
    ],
  },
})
